var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tap-btn-list"},_vm._l((_vm.data),function(item){return _c('li',{key:item.value,class:['tap-btn-list-item', { actived: _vm.value === item.value }],on:{"click":function($event){return _vm.handleClick(item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }